<template>
  <v-row>
    <v-col cols="12" md="9">
      <Dashboard
        :user="user"
        :organizationSettings="organizationSettings"
        :contracts="contracts"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-row>
        <v-col sm="4" md="12">
          <v-card class="elevation-2">
            <v-img
              width="100px"
              src="@/assets/people_mission.png"
              class="mx-auto"
            ></v-img>
            <v-card-title class="py-0 mt-n3">Наша миссия</v-card-title>

            <v-card-text class="pt-0">
              Улучшение качества жизни миллионов людей, которые нам доверяют!
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="4" md="12">
          <v-card class="elevation-2">
            <v-flex xs12>
              <v-img src="@/assets/certificate_bv_iso_9001_2015.png"></v-img>
            </v-flex>

            <v-flex xs12>
              <v-img src="@/assets/certificate_bv_eugdp.png"></v-img>
            </v-flex>

            <v-card-text>
              <p>
                <span class="font-weight-medium"
                  >В портфеле компании более 19900 SKU</span
                >
                (лекарственные средства, БАД, оптические товары, изделия
                медицинского назначения, медицинская техника, косметические и
                парафармацевтические товары).
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="4" md="12">
          <v-card class="elevation-2">
            <v-card-text>
              <a
                class="text-no-decoration"
                target="_blank"
                href="/manuals/WhatsNew.pdf"
              >
                Скачать "Что нового"
              </a>
            </v-card-text>
            <v-card-text>
              <a
                class="text-no-decoration"
                target="_blank"
                href="/manuals/manual_user.pdf"
              >
                Скачать руководство пользователя
              </a>
            </v-card-text>
            <v-card-text>
              <a
                class="text-no-decoration"
                target="_blank"
                href="/manuals/manual_manager.pdf"
              >
                Скачать руководство менеджера
              </a>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Dashboard from "@/components/Dashboard/Dashboard";

export default {
  components: {
    Dashboard,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      organizationSettings: (state) => state.organizations.organizationSettings,
      contracts: (state) => state.organizations.contracts,
    }),
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getOrganizationSettings: "organizations/GET_ORGANIZATION_SETTINGS",
      getContracts: "organizations/GET_CONTRACTS",
    }),
  },
  mounted: async function () {
    await this.getUser(this.user.userId);

    if (!this.user.userRoles.includes("Administrator")) {
      await this.getOrganizationSettings();
      await this.getContracts();
    }
  },
};
</script>
